import React from 'react'
import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { WorkLifeIconCalendar, WorkLifeIconPencil } from '../atoms/icons/WorkLifeIcons'

export const gap: GetCustomerCopyFunc = () => {
  return {
    dependentButtonText: defineMessage({
      defaultMessage: 'No, I’m a dependent or household member',
      description: 'Declaring the current user is a dependent of an eligible user',
    }),
    workLifeServices: [
      {
        identifiers: {
          id: 'tuition',
          dataTestId: 'workLife-selectTuition',
        },
        title: 'Tuition Discounts',
        iconSvg: <WorkLifeIconPencil size={48} />,
        paragraph: '',
        bullets: ['Tuition Reductions', 'Reduced or Waived Payments', 'Discounts for Immediate Family Members'],
        CTA: 'Access Now',
        PATH: 'https://clients.brighthorizons.com/gapinc/matrix',
      },
      {
        identifiers: {
          id: 'wageWorks',
          dataTestId: 'workLife-selectWageWorks',
        },
        title: 'HealthEquity EZ Receipts Commuter Benefits',
        iconSvg: <WorkLifeIconCalendar size={48} />,
        paragraph: 'Save money on eligible transportation costs through automatic paycheck deductions before taxes.',
        bullets: [],
        CTA: 'Register Your Account',
        PATH: 'https://healthequity.com/',
      },
    ],
  }
}
